import { Redirect, Route, Switch } from 'react-router'

import { ProtectedRoute } from '@webapp/app'
import { useAppRoutes } from '@webapp/hooks'
import { Permissions } from '@webapp/platform/iam'
import { ExpenseApprovalsPage } from './ExpenseApprovalsPage'
import { ExpenseDetailPage } from './ExpenseDetailPage'
import { ExpenseEditPage } from './ExpenseEditPage'
import { ExpenseRevisePage } from './ExpenseRevisePage'
import { ExpenseStatusPage } from './ExpenseStatusPage'
import { useModuleConfig } from '../module/useModuleConfig'

export const ExpenseRouter = () => {
  const { brp, url } = useAppRoutes()

  const { showExpenseRoutes } = useModuleConfig()

  if (!showExpenseRoutes) return <Redirect to={url('DashboardPage')} />

  return (
    <Switch>
      <Redirect
        exact
        from={brp('ExpenseApprovalsPage', { status: '' })}
        to={url('ExpenseApprovalsPage', { status: 'pending' })}
      />

      <Redirect
        exact
        from={brp('ExpenseStatusPage', { status: '' })}
        to={url('ExpenseStatusPage', { status: 'pending' })}
      />

      <ProtectedRoute
        path={brp('ExpenseApprovalsPage', { status: ':status' })}
        component={ExpenseApprovalsPage}
        featureFlags={['ARCH_514_MIGRATION_EXPENSE_APPROVALS']}
        permissions={[Permissions.APPROVE_ORDER]}
      />

      <ProtectedRoute
        path={brp('ExpenseStatusPage', { status: ':status' })}
        component={ExpenseStatusPage}
      />

      <ProtectedRoute
        path={brp('ExpenseRevisePage', { uuid: ':uuid' })}
        component={ExpenseRevisePage}
        featureFlags={['ARCH_531_MIGRATION_EXPENSE_DETAILS']}
      />

      <ProtectedRoute
        path={brp('ExpenseEditPage', { uuid: ':uuid' })}
        component={ExpenseEditPage}
        featureFlags={['ARCH_531_MIGRATION_EXPENSE_DETAILS']}
      />

      <ProtectedRoute
        path={brp('ExpenseDetailPage', { uuid: ':uuid' })}
        component={ExpenseDetailPage}
        featureFlags={['ARCH_531_MIGRATION_EXPENSE_DETAILS']}
      />

      <Route
        path='*'
        render={() => (
          <Redirect to={url('ExpenseStatusPage', { status: 'pending' })} />
        )}
      />
    </Switch>
  )
}
